import { Coordinate } from 'openlayers';
import { useCallback, useState } from 'react';
import { CoordToAddr } from 'packages/ui/src/components';
import { JGAMap } from 'packages/ui/src/libs/Map';
import CommonApi from 'api/CommonApi';
import CropApi from 'api/CropApi';
import ApiMapper from 'constant/ApiMapper';
import { set } from 'ol/transform';

const mapper = ApiMapper.CROP;
const CoordToAddrLayout = ({
  jgaMap,
  emdList,
}: {
  emdList: Array<{
    // 동 코드
    emd_nm: string;
    emd_cd: string;
    sgg_cd: string;
    sgg_nm: string;
  }>;
  jgaMap: JGAMap;
}) => {
  const [lock, setLock] = useState(false);
  const [sggName, setSggName] = useState('제주시');
  const [emdName, setEmdName] = useState('');

  const callAddress = useCallback(
    async (coord: Coordinate) => {
      if (lock) return;
      try {
        setLock(true);
        const data = await CommonApi.CoordToAddr({ lat: coord[1], lng: coord[0] });
        if (!data || !data.emd_cd) {
          setEmdName('');
          return;
        }
        
        if(!data || !data.sgg_cd) {
          setSggName('');
        }
        const sgg = data.sgg_nm;
        setSggName(sgg);
        setEmdName(data.emd_nm);

        setLock(false);
      } catch (e) {
        console.error(e);
        setLock(false);
      }
    },
    [lock, emdList],
  );

  const callCoord = async (emdCd) => {
    const emdGeo = await CropApi.GeoJson({ url: mapper.GEO.EMD, regionCode: emdCd });
    jgaMap.drawBorder(emdGeo);
  };

  if (emdList.length < 1) return null;

  return (
    <CoordToAddr
      jgaMap={jgaMap}
      sggName={sggName}
      emdName={emdName}
      emdList={emdList}
      callCoord={callCoord}
      callAddress={callAddress}
    />
  );
};

export default CoordToAddrLayout;
